/**
 * Shared Loyalty is in beta, and every surface that offers it says so in these
 * words — the screen's header and callout, both rail rows. One constant so the
 * day it leaves beta is one deletion rather than a search.
 *
 * Its own file rather than a member of `copy/network.ts`: the sidebar is eager
 * (it renders on every navigation) and needs only `BETA` for the nav row's tag,
 * while the rest of `copy/network.ts` is the lazy network screen's alone. A
 * single shared export pulled that whole module into the sidebar's bundle —
 * `scripts/check-size.mjs`'s initial-payload budget is what caught it.
 */
export const BETA = "Beta";
export const BETA_TITLE = "Shared Loyalty is in beta";
export const BETA_NOTE =
  "How the network works, who is in it and what a coin costs may still change. " +
  "We’ll tell member studios before anything that affects them does.";
